export enum PlasticsShipmentStatus {
    Draft = 'Draft',
    Released = 'Released',
    // Office is done adding products (Released) AND shipping has added their
    // skids — the in-between step before the load actually ships.
    Staged = 'Staged',
    Shipped = 'Shipped',
    Canceled = 'Canceled',
}
